module.exports = __webpack_public_path__ + "img/germany-cardiovascular-diseases-female.06be332b.png";